import { motion } from "framer-motion";
import { Clock, MessageCircle } from "lucide-react";
import { Avatar } from "@/components/Avatar";
import { formateazaRON } from "@/lib/settlement";

// Reamintire blândă — prieteni „pe minus" cu datorii mai vechi de NUDGE_DAYS.
export function NudgeBanner({ datorniciVechi, nudgeDays, onNotify }) {
  if (datorniciVechi.length === 0) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="nudge-banner"
      className="mt-3 rounded-2xl border border-amber-200 bg-amber-50 p-4"
    >
      <div className="flex items-center gap-2 mb-2">
        <div className="h-8 w-8 rounded-full bg-amber-100 flex items-center justify-center shrink-0">
          <Clock className="h-4 w-4 text-amber-600" strokeWidth={2.5} />
        </div>
        <p className="text-sm font-bold text-amber-800">Reamintire blândă</p>
      </div>
      <p className="text-xs text-amber-700/80 mb-3">
        Datorii mai vechi de {nudgeDays} zile. Trimite un mesaj prietenos pe WhatsApp ca să fiți chit.
      </p>
      <div className="space-y-2">
        {datorniciVechi.map(({ m, sold, zile }) => (
          <div
            key={m.id}
            data-testid={`nudge-row-${m.id}`}
            className="flex items-center gap-3 bg-white rounded-xl p-2.5"
          >
            <Avatar name={m.name} size="sm" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-slate-800 truncate">{m.name}</p>
              <p className="text-xs text-rose-500 font-medium">
                pe minus cu {formateazaRON(-sold)} · de {zile} zile
              </p>
            </div>
            <button
              data-testid={`nudge-whatsapp-${m.id}`}
              onClick={() => onNotify(m, sold)}
              className="shrink-0 flex items-center gap-1.5 px-3 py-2 rounded-full bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 active:scale-95 transition-transform"
            >
              <MessageCircle className="h-3.5 w-3.5" strokeWidth={2.5} />
              Reamintește
            </button>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
